import * as React from 'react';
import { ButtonModal } from 'sos-common/js/components/ButtonModal/ButtonModal';
import { saveCloseAction } from './../EServiceFormMenu/eservicemenu.actions';
import { CommonStore } from 'sos-common/js/commonTypes/commonStore.types';
import { getStore } from '../../Redux/store.provider';
import { FormDialogueError } from '../FormDialogueError/FormDialogueError';
import { bindActionCreators } from 'redux';
import { PrintButton } from 'sos-common/js/components/PrintButton/PrintButton';

export interface FormWrapperProps {
  heading: string;
  isOmbudForm?: boolean;
  activeStep: number;
}

export interface FormWrapperState {
  activeStep: number;
}

export class FormWrapper extends React.PureComponent<FormWrapperProps, {}> {
  private readonly formdividerClassName = this.props.isOmbudForm
    ? 'formdivider formdivider--m-t-small formdivider--m-b-large'
    : 'formdivider';
  private readonly formWrapperClassName = this.props.isOmbudForm ? 'form-wrapper form-wrapper--ombud' : 'form-wrapper';

  private _store: CommonStore;
  private _saveOrder: any;
  private _saveAndClose: any;

  componentDidMount() {
    getStore((store) => {
      this._store = store;
      this._saveAndClose = bindActionCreators(saveCloseAction, store.dispatch);
    });
  }

  saveAndClose = () => {
    this._saveAndClose();
  };

  public render() {
    const { children, heading } = this.props;
    return (
      <div className="container eservice-form">
        <FormDialogueError />
        {this.props.isOmbudForm && (
          <div className="form-header form-header--ombud">
            <h1 className="form-header--heading">{heading}</h1>
            <div className="form-header--buttons">
              {this.props.activeStep !== 4 && (
                <ButtonModal
                  buttonText="Spara och stäng"
                  buttonCss="button button--white"
                  modalAction=""
                  modalHeading="Spara och stäng"
                  modalBody="Är du säker på att du vill spara och stänga?"
                  modalCancelText="Avbryt"
                  modalCancelCss="button button--white"
                  modalActionText="Spara och stäng"
                  modalActionCss="button"
                  modalActionUrl="#"
                  callBackLink="#"
                  onActionCompleted={this.saveAndClose}
                />
              )}
              {(this.props.activeStep == 3 || this.props.activeStep == 4) && (
                <PrintButton iconType="print-white" classNames="button button--print" />
              )}
            </div>
            <hr className="formdivider formdivider--form-heading" />
          </div>
        )}
        <form method="post" noValidate={true}>
          <div className="row">
            <main className="col" tabIndex={-1}>
              <div className={this.formWrapperClassName}>
                {!this.props.isOmbudForm && <h1>{heading}</h1>}
                {children}
                <hr className={this.formdividerClassName} />
              </div>
            </main>
          </div>
        </form>
      </div>
    );
  }
}
